export default __webpack_public_path__ + "static/media/ic_instagram.35578152.svg";